import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ReplaySubject } from "rxjs";
import { AuthService } from "../auth/auth.service";
import { HttpService } from "../http/http.service";

declare let window: any;
window.globalObs = {
  me: {
    subject: null,
    fetching: '',
  },
  credit: {
    subject: null,
    fetching: '',
  },
  print: {
    subject: null,
    fetching: '',
  },
}

@Injectable()
export class ShareService {
  private me;
  private credit;
  private print;

  constructor(private httpService: HttpService,
    private authService: AuthService,
    private router: Router,) {
    if (!window.globalObs.me.subject) {
      window.globalObs.me.subject = new ReplaySubject(1);
      this.me = window.globalObs.me;
    } else {
      this.me = window.globalObs.me;
    }

    if (!window.globalObs.credit.subject) {
      window.globalObs.credit.subject = new ReplaySubject(1);
      this.credit = window.globalObs.credit;
    } else {
      this.credit = window.globalObs.credit;
    }

    if (!window.globalObs.print.subject) {
      window.globalObs.print.subject = new ReplaySubject(1);
      this.print = window.globalObs.print;
    } else {
      this.print = window.globalObs.print;
    }
  }

  private getMe() {
    return this.me.subject.asObservable();
  }
  awaitMe() {
    if (!this.me.fetching || this.me.fetching !== location.hash) {
      this.refreshMe();
    }
    return this.getMe();
  }
  refreshMe() {
    this.me.fetching = location.hash;

    this.httpService.get(`/api/members/me`).toPromise()
      .then(
        data => this.me.subject.next(data.json()),
        // err => this.me.subject.error(err)
      ).catch(error => {
        this.authService.removeToken();
        this.router.navigateByUrl('/login');
      });
  }

  private getCredit() {
    return this.credit.subject.asObservable();
  }
  awaitCredit() {
    if (!this.credit.fetching || this.credit.fetching !== location.hash) {
      this.refreshCredit();
    }

    return this.getCredit();
  }
  refreshCredit() {
    this.credit.fetching = location.hash;

    this.httpService.get(`/api/members/credit`).toPromise()
      .then(
        data => this.credit.subject.next(data.json()),
        // err => this.credit.subject.error(err)
      ).catch(error => {
        this.authService.removeToken();
        this.router.navigateByUrl('/login');
      });
  }

  private getPrint() {
    return this.print.subject.asObservable();
  }
  awaitPrint() {
    if (!this.print.fetching || this.print.fetching !== location.hash) {
      this.refreshPrint();
    }

    return this.getPrint();
  }
  refreshPrint() {
    this.print.fetching = location.hash;

    this.httpService.get(`/api/members/print`).toPromise()
      .then(
        data => this.print.subject.next(data.json()),
        // err => this.print.subject.error(err)
      ).catch(error => {
        this.authService.removeToken();
        this.router.navigateByUrl('/login');
      });
  }
}


// WEBPACK FOOTER //
// ./src/app/service/share/share.service.ts